(function () {
  var root = document.querySelector(".tr20-origin");
  if (!root) return;

  var canvas = root.querySelector(".tr20-origin__canvas");
  var track = root.querySelector(".tr20-origin__track");
  var sticky = root.querySelector(".tr20-origin__sticky");
  var beatVideo = root.querySelector(".tr20-origin__beat-video");
  var bootVideo = root.querySelector(".tr20-origin__boot-video");
  var bootReverse = root.querySelector(".tr20-origin__boot-reverse") || bootVideo;
  var bootFallback = root.querySelector(".tr20-origin__boot-fallback");
  var completeCycle = !!(bootVideo && bootVideo.getAttribute("data-complete-cycle") === "true");
  var completePauseRatio = clamp(parseFloat((bootVideo && bootVideo.getAttribute("data-pause-ratio")) || "0.5"), 0.1, 0.9);
  var copyBeats = root.querySelectorAll(".tr20-origin__copy-beat");
  var navButtons = Array.prototype.slice.call(root.querySelectorAll("[data-beat-nav]"));
  var forceReducedMotion =
    /^(?:127\.0\.0\.1|localhost)$/.test(location.hostname) &&
    /(?:\?|&)tr20-reduced-motion=1(?:&|$)/.test(location.search);
  var reducedMotion =
    window.matchMedia("(prefers-reduced-motion: reduce)").matches || forceReducedMotion;
  root.classList.toggle("is-reduced-motion", reducedMotion);
  var iosVideoMode = !!(window.TR20VideoCompat && window.TR20VideoCompat.isIOS);
  var debug = window.TR20Debug && window.TR20Debug.enabled ? window.TR20Debug : null;
  var grainSetting = clamp(parseFloat(root.getAttribute("data-grain") || "0.4"), 0, 1);
  var heatSetting = clamp(parseFloat(root.getAttribute("data-hero-heat") || "0.7"), 0, 1);

  var BEATS = [
    [0.02, 0.22],
    [0.22, 0.42],
    [0.42, 0.64],
    [0.64, 0.88],
  ];
  var LANDING = 0.88;
  var SIT_TRIGGER = 0.45;
  /* Subtle rest pose per Origin beat (%, deg, scale add). */
  var BEAT_POSES = [
    { x: 0, y: 0.12, r: -0.32, s: 0 },
    { x: 0.32, y: 0.38, r: 0.36, s: 0.004 },
    { x: -0.22, y: 0.18, r: -0.26, s: -0.003 },
    { x: 0.18, y: 0.42, r: 0.3, s: 0.003 },
  ];

  var beatSources = [null, null, null, null];
  root.querySelectorAll(".tr20-origin__beat-src").forEach(function (el) {
    var index = parseInt(el.getAttribute("data-beat") || "-1", 10);
    if (index >= 0 && index < 4) beatSources[index] = el.getAttribute("data-src") || "";
  });
  if (beatVideo && beatVideo.getAttribute("data-src")) {
    beatSources[0] = beatVideo.getAttribute("data-src");
  }
  var beatVideos = [];
  var activeBeatVideo = null;
  var warmedBeats = {};
  var lastUploadedVideo = null;
  var lastUploadedTime = -1;
  var videoFrameDirty = true;
  var beatUploadFailures = 0;
  var usesVideoFrameCallback = false;
  var beatPrepared = false;
  var beatRevealAt = -1;
  var beatRevealElapsed = 0;
  var lastRevealStepAt = 0;
  var BEAT_REVEAL_MS = 720;
  var FRAME_INTERVAL = iosVideoMode ? 40 : 30;
  var videoReveal = 0;
  var bootRevealed = false;
  var bootFullyLoaded = false;
  var videoFrameCanvas = document.createElement("canvas");
  var videoFrameCtx = videoFrameCanvas.getContext("2d", { alpha: false });
  var bootBufferWaitStarted = 0;
  var bootBufferTimer = 0;
  var bootBufferWarmStarted = false;
  var BOOT_BUFFER_RATIO = 0.5;
  var BOOT_BUFFER_MAX_WAIT = 6500;
  var mediaFallbackActive = false;
  var mediaGestureRetryBound = false;
  var mediaGestureRetrying = false;
  var simulateMediaBlock = !!(
    window.TR20VideoCompat &&
    window.TR20VideoCompat.isLocalPreview &&
    /(?:\?|&)tr20-media-fallback=1(?:&|$)/.test(location.search)
  );

  function debugSet(key, value) {
    if (debug) debug.set(key, value);
  }

  function clearMediaFallback() {
    if (!mediaFallbackActive) return;
    mediaFallbackActive = false;
    root.classList.remove("is-media-fallback");
    debugSet("media.fallback", "cleared — video texture ready");
  }

  function retryMediaFromGesture() {
    if (!mediaFallbackActive || mediaGestureRetrying || simulateMediaBlock) return;
    mediaGestureRetrying = true;
    window.setTimeout(function () { mediaGestureRetrying = false; }, 500);

    if (!introDone && bootVideo) {
      bootBufferWarmStarted = false;
      warmBootBuffer();
    }

    if (!beatPrepared) prepareBeatVideos();
    if (beatVideo && beatVideo.paused) {
      beatVideo.muted = true;
      beatVideo.playsInline = true;
      var play = beatVideo.play();
      if (play && typeof play.then === "function") {
        play.then(function () {
          debugSet("background.gestureRetry", "ok");
          videoFrameDirty = true;
          requestDraw();
        }).catch(function (error) {
          debugSet("background.gestureRetry", "FAIL " + (error && error.name ? error.name : error));
        });
      }
    }
  }

  function bindMediaGestureRetry() {
    if (mediaGestureRetryBound) return;
    mediaGestureRetryBound = true;
    document.addEventListener("pointerdown", retryMediaFromGesture, { passive: true, capture: true });
    document.addEventListener("touchstart", retryMediaFromGesture, { passive: true, capture: true });
  }

  function activateMediaFallback(reason) {
    mediaFallbackActive = true;
    root.classList.add("is-media-fallback");
    debugSet("media.fallback", reason || "autoplay blocked");
    bindMediaGestureRetry();
    requestDraw();
  }

  debugSet("origin.mode", "ios=" + iosVideoMode + " reducedMotion=" + reducedMotion);

  var state = {
    p: 0,
    heroHeat: 0,
    grain: grainSetting,
    blur: 1,
    mark: 0,
    hasVideo: 0,
    copyX: 0.22,
    copyY: 0.5,
    copyRx: 0.28,
    copyRy: 0.22,
    copyStrength: 0,
    copyBand: 0,
    videoFade: 0,
    videoAspect: 1,
    videoTiles: 1,
    markTiles: 5.1,
    tileMix: 0,
    tileAspect: 2.4,
  };

  var introT = 0;
  var introDone = false;
  var introStarted = false;
  var introStartQueued = false;
  var introStartReady = false;
  var heatStart = 0;
  var HEAT_MS = 10000;
  var scrollP = 0;
  var activeBeat = -1;
  var activeCopy = -1;
  var bootNudgeAt = -1;
  var copyMaskAt = -1;
  var COPY_MASK_MS = 560;
  var raf = 0;
  var drawing = false;
  var inView = true;
  var pageBackground = false;
  var start = performance.now();
  var gl = null;
  var program = null;
  var uniforms = {};
  var markTex = null;
  var tileTex = null;
  var videoTex = null;
  var width = 1;
  var height = 1;
  var navHeight = -1;
  var lastRenderAt = 0;
  var clicking = false;
  var reverseLoaded = false;
  var reverseLoadStarted = false;
  var sitDir = 0;
  var sitShowing = false;
  var sitPainted = false;
  var sitRaf = 0;
  var introReverseRaf = 0;
  var sitPlayhead = 0;
  var sitReadyBound = false;
  var lastScrollY = -1;
  var lastScrollP = 0;
  var INTRO_RATE = 1.2;
  var SIT_RATE = 1.8;
  var LIFT_RATE = 2;
  var liftGen = 0;
  var liftPlaying = false;
  var groundRestAt = 0;
  var lastSettleNow = 0;
  var poseSettling = false;
  var shown = null;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function mix(a, b, t) {
    return a + (b - a) * clamp(t, 0, 1);
  }

  function isMobile() {
    return window.matchMedia("(max-width: 980px)").matches;
  }

  function stickyProgress(el) {
    if (!el) return 0;
    var vh = Math.max(window.innerHeight || 1, 1);
    var rect = el.getBoundingClientRect();
    var maxTravel = Math.max(el.offsetHeight - vh, 1);
    return clamp(-rect.top / maxTravel, 0, 1);
  }

  function envelope(p, a, b) {
    if (p <= a || p >= b) return 0;
    var local = (p - a) / (b - a);
    if (local < 0.15) return local / 0.15;
    if (local < 0.8) return 1;
    return clamp(1 - (local - 0.8) / 0.2, 0, 1);
  }

  function measureNav() {
    var nav = document.getElementById("nav-fixed-top");
    var h = nav ? Math.ceil(nav.getBoundingClientRect().height) : 0;
    if (h === navHeight) return;
    navHeight = h;
    root.style.setProperty("--nav-offset", h + "px");
    if (gl) resize();
  }

  function setScrollLock(lock) {
    document.documentElement.style.overflow = lock ? "hidden" : "";
    document.body.style.overflow = lock ? "hidden" : "";
  }

  function landingT(sp) {
    if (sp < LANDING) return 0;
    return clamp((sp - LANDING) / Math.max(0.0001, 1 - LANDING), 0, 1);
  }

  function smoother(t) {
    t = clamp(t, 0, 1);
    return t * t * (3 - 2 * t);
  }

  function contactT(sp) {
    if (sp < LANDING) return 0;
    return smoother((landingT(sp) - 0.58) / 0.42);
  }

  function brightnessT(sp) {
    var timed = heatStart ? clamp((performance.now() - heatStart) / HEAT_MS, 0, 1) : 0;
    var scrolled = clamp(sp / 0.58, 0, 1);
    var t = Math.max(timed, scrolled);
    return smoother(t);
  }

  function heroHeat(reveal, sp) {
    var heat = mix(0.03, 1.0, brightnessT(sp));
    if (sp >= LANDING) heat = mix(1.0, 0.76, Math.pow(landingT(sp), 1.1));
    return heat * heatSetting;
  }

  function markAmount(reveal, sp) {
    var videoRise = clamp((reveal - 0.12) / 0.88, 0, 1) * 0.92;
    var rise = Math.max(brightnessT(sp), videoRise);
    var amount = mix(0.03, 1.48, Math.pow(rise, 1.15));
    if (sp > 0 && sp < LANDING) {
      var settle = clamp((sp - 0.2) / 0.38, 0, 1);
      settle = smoother(settle);
      amount = mix(amount, 0.72, settle);
    }
    if (sp >= LANDING) amount = mix(0.72, 0.8, landingT(sp));
    return amount;
  }

  function blurAmount(reveal, sp) {
    if (sp > 0.02 && sp < LANDING) return 0.22;
    if (sp >= LANDING) return mix(0.22, 0.12, landingT(sp));
    return 0;
  }

  function groundOpacity(reveal, sp) {
    if (sp < LANDING) return 0;
    return Math.pow(contactT(sp), 1.05);
  }

  function groundRise(reveal, sp) {
    if (sp < LANDING) return 18;
    return mix(18, 0, Math.pow(contactT(sp), 1.15));
  }

  function bootShadow(reveal, sp) {
    if (sp < LANDING) return 0;
    return mix(0, 0.58, Math.pow(contactT(sp), 1.25));
  }

  function bootInset(sp) {
    return contactT(sp);
  }

  function canvasOpacity(sp) {
    if (sp < LANDING) return 1;
    var t = clamp((landingT(sp) - 0.7) / 0.3, 0, 1);
    return mix(1, 0.54, smoother(t));
  }

  function updateCanvasPlacement(sp) {
    var shouldPersist = sp >= 0.975;
    if (shouldPersist === pageBackground || !canvas || !sticky) return;
    pageBackground = shouldPersist;
    if (pageBackground) {
      var stickyTop = Math.max(0, sticky.getBoundingClientRect().top);
      canvas.style.setProperty("--tr20-canvas-top", Math.round(stickyTop) + "px");
      canvas.classList.add("is-page-background");
      document.body.appendChild(canvas);
      inView = true;
    } else {
      canvas.style.removeProperty("--tr20-canvas-top");
      canvas.classList.remove("is-page-background");
      sticky.insertBefore(canvas, sticky.firstChild);
      inView = true;
    }
    resize();
    requestDraw();
  }

  function updateGroundRest(force) {
    var now = performance.now();
    if (!force && now - groundRestAt < 280) return;
    var media =
      (sitShowing && bootReverse) || bootVideo || root.querySelector(".tr20-origin__boot-img");
    var ground = root.querySelector(".tr20-origin__ground");
    if (!media || !ground || !sticky) return;
    var stickyRect = sticky.getBoundingClientRect();
    var mediaRect = media.getBoundingClientRect();
    if (mediaRect.height < 8) return;
    groundRestAt = now;
    var toeY = mediaRect.top + mediaRect.height * 0.9;
    var padH = Math.max(ground.offsetHeight, 1);
    var rest = stickyRect.bottom - padH - toeY + 8;
    root.style.setProperty("--ground-rest", Math.round(rest) + "px");
  }

  function sceneNavOpacity(sp, introComplete) {
    if (!introComplete) return 0;
    if (sp < 0.02) return 0;
    if (sp < 0.08) return smoother((sp - 0.02) / 0.06);
    if (sp >= LANDING) return 1 - smoother(landingT(sp) / 0.48);
    return 1;
  }

  function updateNav(active) {
    navButtons.forEach(function (button) {
      var index = parseInt(button.getAttribute("data-beat-nav") || "-1", 10);
      var on = index === active && active >= 0;
      button.classList.toggle("is-active", on);
      button.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function progressForBeat(index) {
    var start = BEATS[index][0];
    var end = BEATS[index][1];
    return mix(start, end, 0.28);
  }

  function scrollToProgress(target) {
    if (!track) return;
    var vh = Math.max(window.innerHeight || 1, 1);
    var maxTravel = Math.max(track.offsetHeight - vh, 1);
    var top = window.scrollY + track.getBoundingClientRect().top + target * maxTravel;
    window.scrollTo({ top: top, behavior: reducedMotion ? "auto" : "smooth" });
  }

  function goToBeat(index) {
    if (!introDone) return;
    if (isMobile()) {
      clicking = false;
      scrollToProgress(progressForBeat(index));
      return;
    }
    clicking = true;
    scrollToProgress(progressForBeat(index));
    window.setTimeout(function () {
      clicking = false;
      updateAll();
    }, 1400);
  }

  function applyShown(pose, ground, groundY, shadow, inset, ui) {
    var now = performance.now();
    if (!shown || reducedMotion) {
      shown = {
        x: pose.x,
        y: pose.y,
        s: pose.s,
        r: pose.r,
        o: pose.o,
        ground: ground,
        groundY: groundY,
        shadow: shadow,
        inset: inset,
        ui: ui,
      };
      lastSettleNow = now;
      poseSettling = false;
      return shown;
    }
    var dt = clamp(now - lastSettleNow, 8, 48);
    lastSettleNow = now;
    var k = 1 - Math.exp(-dt / 150);
    shown.x += (pose.x - shown.x) * k;
    shown.y += (pose.y - shown.y) * k;
    shown.s += (pose.s - shown.s) * k;
    shown.r += (pose.r - shown.r) * k;
    shown.o += (pose.o - shown.o) * k;
    shown.ground += (ground - shown.ground) * k;
    shown.groundY += (groundY - shown.groundY) * k;
    shown.shadow += (shadow - shown.shadow) * k;
    shown.inset += (inset - shown.inset) * k;
    shown.ui += (ui - shown.ui) * k;
    var err =
      Math.abs(pose.y - shown.y) +
      Math.abs(pose.x - shown.x) +
      Math.abs(ground - shown.ground) +
      Math.abs(shadow - shown.shadow) +
      Math.abs(ui - shown.ui);
    poseSettling = err > 0.014;
    return shown;
  }

  function signatureOpacity(sp, introComplete, ui) {
    if (!introComplete) return 1;
    if (sp >= 0.08) return 0;
    return clamp(1 - ui, 0, 1);
  }

  function beatNudge() {
    if (reducedMotion || bootNudgeAt < 0) return 0;
    var t = (performance.now() - bootNudgeAt) / 160;
    if (t >= 1) return 0;
    return Math.sin(t * Math.PI);
  }

  function beatMotion(sp) {
    var rest = { x: 0, y: 0, r: 0, s: 0 };
    if (reducedMotion || sp < BEATS[0][0] || sp >= LANDING) return rest;
    var i = currentBeatIndex(sp);
    if (i < 0) {
      i = 0;
      for (var k = 0; k < BEATS.length; k++) {
        if (sp >= BEATS[k][0]) i = k;
      }
    }
    var a = BEATS[i][0];
    var b = BEATS[i][1];
    var local = clamp((sp - a) / Math.max(0.0001, b - a), 0, 1);
    var pose = BEAT_POSES[i];
    var next = BEAT_POSES[Math.min(i + 1, BEAT_POSES.length - 1)];
    var handoff = i < BEAT_POSES.length - 1 ? clamp((local - 0.88) / 0.12, 0, 1) : 0;
    var kick = beatNudge();
    return {
      x: mix(pose.x, next.x, handoff),
      y: mix(pose.y, next.y, handoff) - kick * 0.55,
      r: mix(pose.r, next.r, handoff) + kick * 0.22,
      s: mix(pose.s, next.s, handoff) + kick * 0.006,
    };
  }

  function bootPose(reveal, sp, mobile) {
    var y = 0;
    var x = 0;
    var s = 1;
    var r = 0;
    var o = 1;
    if (sitShowing) {
      if (!mobile && sp > 0.02) {
        var sitT = Math.min(1, (sp - 0.02) / 0.1);
        var sitBeat = sp < LANDING ? beatMotion(sp) : BEAT_POSES[BEAT_POSES.length - 1];
        x = -11 * sitT + sitBeat.x;
      }
      y = mobile ? -4 : 0;
      r = 0;
      s = 1;
    } else if (sp > 0.02 && sp < LANDING) {
      var t = Math.min(1, (sp - 0.02) / 0.1);
      var beat = beatMotion(sp);
      x = (mobile ? 0 : -11 * t) + (mobile ? 0 : beat.x);
      y = (mobile ? mix(0, -5, t) : 0) + (mobile ? beat.y * 0.2 : beat.y);
      r = mobile ? beat.r * 0.35 : beat.r;
      s = 1;
    } else if (sp >= LANDING) {
      var last = BEAT_POSES[BEAT_POSES.length - 1];
      x = mobile ? 0 : -11 + last.x;
      y = (mobile ? -6 : 0) + last.y;
      r = mobile ? last.r * 0.35 : last.r;
      s = 1;
      o = 1;
    }
    return { y: y, x: x, s: s, r: r, o: o };
  }

  function markTilesFor(sp, introComplete) {
    var target = isMobile() ? 2.6 : 3.7;
    var start = 0.48;
    if (!introComplete || sp < 0.01) return start;
    if (sp < LANDING) {
      var t = clamp((sp - 0.01) / 0.14, 0, 1);
      t = smoother(t);
      return mix(start, target, t);
    }
    var lt = smoother(landingT(sp));
    return mix(target, mix(target, start, 0.28), lt);
  }

  function tileMixFor() {
    return 1;
  }

  function currentBeatIndex(p) {
    for (var i = 0; i < BEATS.length; i++) {
      if (p >= BEATS[i][0] && p < BEATS[i][1]) return i;
    }
    return -1;
  }

  function copyBeatIndex(p) {
    if (p >= LANDING) return BEATS.length - 1;
    return currentBeatIndex(p);
  }

  function activateCopyBeat(p) {
    var next = copyBeatIndex(p);
    if (next === activeCopy) return;
    var previous = activeCopy;
    activeCopy = next;
    if (!reducedMotion && previous >= 0 && next >= 0) copyMaskAt = performance.now();
    if (previous >= 0 && copyBeats[previous]) {
      var leaving = copyBeats[previous];
      leaving.classList.remove("is-active");
      leaving.classList.add("is-leaving");
      window.setTimeout(function () {
        if (!leaving.classList.contains("is-active")) leaving.classList.remove("is-leaving");
      }, 280);
    }
    if (next >= 0 && copyBeats[next]) {
      var entering = copyBeats[next];
      entering.classList.remove("is-leaving");
      void entering.offsetWidth;
      entering.classList.add("is-active");
    }
    updateNav(next);
  }

  function copyMaskTransition() {
    if (reducedMotion || copyMaskAt < 0) return 1;
    var t = (performance.now() - copyMaskAt) / COPY_MASK_MS;
    if (t >= 1) return 1;
    if (t < 0.22) return 1 - smoother(t / 0.22);
    if (t < 0.38) return 0;
    return smoother((t - 0.38) / 0.62);
  }

  function updateCopyMask(p) {
    var mobile = isMobile();
    var lt = landingT(p);
    if (pageBackground || lt > 0.88) {
      state.copyStrength = mix(state.copyStrength, 0, 0.22);
      return;
    }
    state.copyBand = mobile ? 0.78 : 0;
    var strongestEl = activeCopy >= 0 ? copyBeats[activeCopy] : null;
    var landingStrength = 1 - smoother(lt / 0.62);
    state.copyStrength = activeCopy >= 0 ? copyMaskTransition() * landingStrength : 0;
    if (!strongestEl || !sticky || state.copyStrength < 0.04) return;
    var stickyRect = sticky.getBoundingClientRect();
    var copyRect = strongestEl.getBoundingClientRect();
    var originW = Math.max(stickyRect.width, 1);
    var originH = Math.max(stickyRect.height, 1);
    state.copyX = (copyRect.left + copyRect.width / 2 - stickyRect.left) / originW;
    state.copyY = 1 - (copyRect.top + copyRect.height / 2 - stickyRect.top) / originH;
    state.copyRx = mobile ? Math.max(0.72, (copyRect.width / originW) * 0.75) : Math.max(0.2, (copyRect.width / originW) * 2.15);
    state.copyRy = mobile ? Math.max(0.42, (copyRect.height / originH) * 1.4) : Math.max(0.2, (copyRect.height / originH) * 2.85);
  }

  function prepareBeatVideos() {
    if (beatPrepared || !beatVideo || !beatSources[0]) return;
    beatPrepared = true;
    beatVideo.muted = true;
    beatVideo.playsInline = true;
    beatVideo.loop = true;
    beatVideo.preload = "auto";
    beatVideo.crossOrigin = "anonymous";
    beatVideo.src = beatSources[0];
    beatVideo.addEventListener("loadeddata", function () {
      try {
        if (this.duration) this.currentTime = Math.min(0.04, this.duration * 0.02);
      } catch (e) {}
      videoFrameDirty = true;
      applyScene();
      requestDraw();
      releaseIdleMedia();
    });
    if (typeof beatVideo.requestVideoFrameCallback === "function") {
      usesVideoFrameCallback = true;
      var onVideoFrame = function () {
        videoFrameDirty = true;
        requestDraw();
        beatVideo.requestVideoFrameCallback(onVideoFrame);
      };
      beatVideo.requestVideoFrameCallback(onVideoFrame);
    }
    try {
      beatVideo.load();
    } catch (e2) {}
    for (var i = 0; i < beatSources.length; i++) {
      beatVideos[i] = beatVideo;
    }
    beatVideo.addEventListener("canplaythrough", releaseIdleMedia, { once: true });
    beatVideo.addEventListener("error", releaseIdleMedia, { once: true });
    setTimeout(releaseIdleMedia, 3500);
  }

  function bootVideoComplete() {
    if (!bootVideo) return true;
    if (bootVideo.readyState >= 4) return true;
    try {
      if (bootVideo.duration && bootVideo.buffered.length) {
        return bootVideo.buffered.end(bootVideo.buffered.length - 1) >= bootVideo.duration - 0.2;
      }
    } catch (e) {}
    return false;
  }

  function bootBufferedRatio() {
    if (!bootVideo) return 1;
    var duration = bootVideo.duration;
    if (!duration || !isFinite(duration)) return 0;
    var bufferedEnd = 0;
    try {
      for (var i = 0; i < bootVideo.buffered.length; i++) {
        bufferedEnd = Math.max(bufferedEnd, bootVideo.buffered.end(i));
      }
    } catch (e) {}
    return clamp(bufferedEnd / duration, 0, 1);
  }

  function warmBootBuffer() {
    if (!bootVideo || bootBufferWarmStarted) return;
    bootBufferWarmStarted = true;
    bootVideo.muted = true;
    bootVideo.playsInline = true;
    bootVideo.loop = true;
    if (simulateMediaBlock) {
      bootBufferWarmStarted = false;
      activateMediaFallback("simulated autoplay block");
      showBootFallback();
      return;
    }
    var play = bootVideo.play();
    if (play && typeof play.then === "function") {
      play.then(function () {
        debugSet("boot.warmup", "playing hidden");
      }).catch(function (error) {
        bootBufferWarmStarted = false;
        debugSet("boot.warmup", "FAIL " + (error && error.name ? error.name : error));
        activateMediaFallback("boot autoplay blocked: " + (error && error.name ? error.name : error));
        showBootFallback();
      });
    }
  }

  function finishBootBufferWarmup() {
    if (!bootVideo || !bootBufferWarmStarted) return;
    bootVideo.pause();
    bootVideo.loop = false;
    try {
      bootVideo.currentTime = 0;
    } catch (e) {}
    debugSet("boot.warmup", "complete");
  }

  var userScrolled = false;
  var idleMediaSent = false;

  function connectionConstrained() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    var type = String(c.effectiveType || "");
    return type === "slow-2g" || type === "2g";
  }

  function releaseIdleMedia() {
    if (idleMediaSent) return;
    idleMediaSent = true;
    document.dispatchEvent(new CustomEvent("landing:idle-media"));
  }

  function tryStartBeatVideo() {
    var bootReady = bootVideoComplete() ||
      (iosVideoMode && userScrolled);
    if (!bootFullyLoaded && !bootReady) return;
    bootFullyLoaded = true;
    if (connectionConstrained() && !userScrolled) return;
    if (!beatPrepared) {
      prepareBeatVideos();
    }
    if (!beatVideo || !beatSources[0]) releaseIdleMedia();
    else if (beatVideo.readyState >= 2) releaseIdleMedia();
  }

  function bindBootThenBeat() {
    document.addEventListener(
      "scroll",
      function () {
        userScrolled = true;
        tryStartBeatVideo();
      },
      { once: true, passive: true }
    );
    if (!bootVideo) {
      bootFullyLoaded = true;
      return;
    }
    var onBootReady = function () {
      if (bootVideoComplete()) {
        bootFullyLoaded = true;
        tryStartBeatVideo();
      }
    };
    if (bootVideoComplete()) {
      onBootReady();
      return;
    }
    bootVideo.addEventListener("canplaythrough", onBootReady);
    bootVideo.addEventListener("progress", onBootReady);
    bootVideo.addEventListener("loadeddata", onBootReady);
  }

  function warmBeat(index) {
    var video = beatVideos[index];
    if (!video || warmedBeats[index]) return;
    warmedBeats[index] = true;
    if (video.readyState < 2) {
      video.load();
      return;
    }
    var play = video.play();
    if (play && typeof play.then === "function") {
      play
        .then(function () {
          window.setTimeout(function () {
            if (video !== activeBeatVideo) video.pause();
          }, 140);
        })
        .catch(function () {});
    }
  }

  function originVideoReady() {
    return !!(beatVideo && beatVideo.readyState >= 2);
  }

  function stepVideoReveal(now, texReady) {
    var want = introDone && scrollP > 0.02 && texReady;
    if (!want) return;
    if (beatRevealAt < 0) {
      beatRevealAt = now;
      lastRevealStepAt = now;
      beatRevealElapsed = 0;
      videoReveal = 0;
      return;
    }
    if (videoReveal >= 1) return;
    var dt = Math.min(Math.max(now - lastRevealStepAt, 0), 48);
    lastRevealStepAt = now;
    beatRevealElapsed += dt;
    videoReveal = smoother(clamp(beatRevealElapsed / BEAT_REVEAL_MS, 0, 1));
  }

  function revealBootMedia() {
    if (bootRevealed || !bootVideo) return;
    bootRevealed = true;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        bootVideo.classList.add("is-revealed");
        if (!bootNeedsStackedRenderer() || bootVideo.__tr20StackedReady) {
          hideBootFallback();
        }
        window.setTimeout(function () {
          bootVideo.classList.add("is-reveal-complete");
        }, 620);
      });
    });
  }

  function bootNeedsStackedRenderer() {
    if (!bootVideo || bootVideo.getAttribute("data-stacked-alpha") !== "true") return false;
    if (window.TR20VideoCompat) return !!window.TR20VideoCompat.usesFallback;
    var ua = navigator.userAgent || "";
    var ios = /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    return ios || location.hostname === "127.0.0.1" || location.hostname === "localhost";
  }

  function hideBootFallback() {
    if (!bootFallback) return;
    bootFallback.classList.remove("is-fallback-visible");
    bootFallback.classList.add("is-media-ready");
  }

  function showBootFallback() {
    if (!bootFallback) return;
    bootFallback.classList.remove("is-media-ready");
    bootFallback.classList.add("is-fallback-visible");
    debugSet("boot.fallback", "shown after media failure");
  }

  function uploadBeatFrame(liveVideo) {
    if (!gl || !videoTex) return false;
    gl.activeTexture(gl.TEXTURE1);
    gl.bindTexture(gl.TEXTURE_2D, videoTex);
    if (
      liveVideo &&
      (activeBeatVideo !== lastUploadedVideo ||
        (usesVideoFrameCallback ? videoFrameDirty : Math.abs(activeBeatVideo.currentTime - lastUploadedTime) > 0.001))
    ) {
      try {
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 0);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, videoFrameSource(activeBeatVideo));
        lastUploadedVideo = activeBeatVideo;
        lastUploadedTime = activeBeatVideo.currentTime;
        videoFrameDirty = false;
        beatUploadFailures = 0;
        clearMediaFallback();
        debugSet("origin.videoTexture", "painted " + videoFrameCanvas.width + "x" + videoFrameCanvas.height);
      } catch (e) {
        beatUploadFailures += 1;
        debugSet("origin.videoTexture", "FAIL " + beatUploadFailures + " " + (e && e.message ? e.message : e));
      }
    }
    return !!(liveVideo && lastUploadedVideo === activeBeatVideo);
  }

  function originVideoFade(p) {
    if (!introDone || p <= 0.02) return 0;
    var fade = videoReveal;
    if (p >= LANDING) fade *= 1 - smoother(landingT(p) / 0.7);
    if (isMobile()) fade *= 0.9;
    return fade;
  }

  function syncBeatVideo(p) {
    if (!beatVideos.length) return;
    var next = currentBeatIndex(p);
    if (next < 0 && p >= 0.01) next = p >= LANDING ? BEATS.length - 1 : 0;
    if (next !== activeBeat) {
      if (next >= 0 && currentBeatIndex(p) >= 0) bootNudgeAt = performance.now();
      if (activeBeatVideo && activeBeatVideo !== beatVideos[next]) {
        try {
          activeBeatVideo.pause();
        } catch (e) {}
      }
      activeBeat = next;
      activeBeatVideo = next >= 0 ? beatVideos[next] || null : null;
      lastUploadedVideo = null;
      lastUploadedTime = -1;
      videoFrameDirty = true;
      if (activeBeatVideo) {
        try {
          if (activeBeatVideo.ended) activeBeatVideo.currentTime = 0;
        } catch (e2) {}
        var play = activeBeatVideo.play();
        if (play && typeof play.then === "function") {
          play.then(function () {
            debugSet("background.play", "ok");
          }).catch(function (error) {
            debugSet("background.play", "FAIL " + (error && error.name ? error.name : error));
            activateMediaFallback("background autoplay blocked: " + (error && error.name ? error.name : error));
          });
        }
      }
    }
    var liveVideo = activeBeatVideo && activeBeatVideo.readyState >= 2;
    state.videoFade = originVideoFade(p);
    state.hasVideo = state.videoFade > 0.01 && liveVideo ? 1 : 0;
    if (liveVideo && activeBeatVideo.videoWidth > 1) {
      state.videoAspect = activeBeatVideo.videoWidth / Math.max(activeBeatVideo.videoHeight, 1);
    }
    if (next >= 0 && next < BEATS.length - 1 && p > BEATS[next][1] - 0.05) warmBeat(next + 1);
    state.videoTiles = 1;
  }

  function reverseTime() {
    if (!bootReverse) return 0;
    var dur = bootReverse.duration || 0;
    if (bootReverse.ended && dur) return dur;
    return bootReverse.currentTime || 0;
  }

  function reverseDuration() {
    return (bootReverse && bootReverse.duration) || 0;
  }

  function completePauseTime() {
    return reverseDuration() * completePauseRatio;
  }

  function isPlantedEnd() {
    if (!bootReverse) return false;
    var dur = reverseDuration();
    if (bootReverse.ended) return true;
    if (dur && reverseTime() >= dur - 0.05) return true;
    if (sitShowing && sitDir === 0 && dur) return true;
    return false;
  }

  function noteScrollDir(sp) {
    var y = window.scrollY || 0;
    var dir = 0;
    if (lastScrollY >= 0) {
      if (y < lastScrollY - 0.5 || sp < lastScrollP - 0.0008) dir = -1;
      else if (y > lastScrollY + 0.5 || sp > lastScrollP + 0.0008) dir = 1;
    }
    lastScrollY = y;
    lastScrollP = sp;
    return dir;
  }

  function stopSitRaf() {
    if (sitRaf) {
      window.cancelAnimationFrame(sitRaf);
      sitRaf = 0;
    }
  }

  function paintBootFrame(video, attempts) {
    if (!video) return;
    var remaining = typeof attempts === "number" ? attempts : 30;
    if (video.readyState >= 2 && !video.seeking) {
      if (typeof video.__tr20DrawStackedFrame === "function") video.__tr20DrawStackedFrame();
      return;
    }
    if (remaining > 0) {
      window.requestAnimationFrame(function () {
        paintBootFrame(video, remaining - 1);
      });
    }
  }

  function paintAndRevealBoot(video, attempts) {
    if (!video) return;
    var remaining = typeof attempts === "number" ? attempts : 90;
    if (video.readyState >= 2 && !video.seeking) {
      if (typeof video.__tr20DrawStackedFrame === "function") video.__tr20DrawStackedFrame();
      root.classList.remove("is-boot-preparing");
      revealBootMedia();
      return;
    }
    if (remaining > 0) {
      window.requestAnimationFrame(function () {
        paintAndRevealBoot(video, remaining - 1);
      });
    }
  }

  function introDuration() {
    return (bootVideo && bootVideo.duration) || 0;
  }

  function introTime() {
    if (!bootVideo) return 0;
    var dur = introDuration();
    if (bootVideo.ended && dur) return dur;
    return bootVideo.currentTime || 0;
  }

  function reverseProgress() {
    var dur = reverseDuration();
    if (!dur) return isPlantedEnd() ? 1 : 0;
    if (isPlantedEnd()) return 1;
    return clamp(reverseTime() / dur, 0, 1);
  }

  function introTimeFromReverse() {
    var introDur = introDuration();
    if (!introDur) return 0;
    return introDur * reverseProgress();
  }

  function reverseTimeFromIntro() {
    var introDur = introDuration();
    var revDur = reverseDuration();
    if (!revDur) return reverseTime();
    if (!introDur) return reverseTime();
    return revDur * clamp(introTime() / introDur, 0, 1);
  }

  function onReversePainted() {
    sitPainted = true;
    if (sitShowing) return;
    sitShowing = true;
    root.classList.add("is-boot-sit");
    if (sitDir !== -1 && bootVideo !== bootReverse) {
      try {
        if (bootVideo) bootVideo.pause();
      } catch (e) {}
    }
    updateGroundRest(true);
  }

  function waitForReversePaint() {
    if (!bootReverse) return;
    if (sitPainted) {
      onReversePainted();
      return;
    }
    if (typeof bootReverse.requestVideoFrameCallback === "function") {
      bootReverse.requestVideoFrameCallback(function () {
        onReversePainted();
      });
      return;
    }
    bootReverse.addEventListener("playing", onReversePainted, { once: true });
    bootReverse.addEventListener("timeupdate", onReversePainted, { once: true });
    bootReverse.addEventListener("seeked", onReversePainted, { once: true });
  }

  function freezeSitEnd() {
    stopSitRaf();
    sitDir = 0;
    if (!bootReverse) return;
    var dur = reverseDuration();
    try {
      bootReverse.pause();
      if (dur) bootReverse.currentTime = Math.max(dur - 0.08, 0);
    } catch (e) {}
    sitPlayhead = dur || reverseTime();
    paintBootFrame(bootReverse);
    onReversePainted();
  }

  function finishLiftOff() {
    liftGen += 1;
    liftPlaying = false;
    stopSitRaf();
    sitDir = 0;
    sitPlayhead = 0;
    root.classList.remove("is-boot-sit");
    root.classList.remove("is-boot-lift");
    sitShowing = false;
    sitPainted = false;
    if (bootReverse) {
      try {
        bootReverse.pause();
        bootReverse.playbackRate = 1;
        bootReverse.currentTime = completeCycle ? completePauseTime() : 0;
      } catch (e) {}
    }
    if (completeCycle) {
      paintBootFrame(bootVideo);
      return;
    }
    if (!bootVideo) return;
    try {
      bootVideo.pause();
      bootVideo.playbackRate = INTRO_RATE;
      bootVideo.currentTime = 0;
    } catch (e2) {}
    paintBootFrame(bootVideo);
  }

  function revealIntroLayer() {
    if (sitDir !== -1) return;
    root.classList.remove("is-boot-sit");
    root.classList.remove("is-boot-lift");
    sitShowing = false;
    sitPainted = false;
    updateGroundRest(true);
  }

  function waitForIntroLiftPaint(gen) {
    if (!bootVideo) {
      revealIntroLayer();
      return;
    }
    var done = false;
    function onPaint() {
      if (done || gen !== liftGen || sitDir !== -1) return;
      done = true;
      revealIntroLayer();
    }
    if (typeof bootVideo.requestVideoFrameCallback === "function") {
      bootVideo.requestVideoFrameCallback(function () {
        onPaint();
      });
    }
    bootVideo.addEventListener("playing", onPaint, { once: true });
    bootVideo.addEventListener("timeupdate", onPaint, { once: true });
    window.setTimeout(onPaint, 320);
  }

  function playSitRewind() {
    if (!bootReverse) return;
    if (completeCycle) {
      playCompleteLift();
      return;
    }
    if (sitDir === -1) return;
    var t = reverseTime();
    var atEnd = isPlantedEnd();
    if (!sitShowing && sitDir !== 1 && !atEnd && t <= 0.02) {
      sitDir = 0;
      return;
    }
    stopSitRaf();
    liftGen += 1;
    var gen = liftGen;
    sitDir = -1;
    liftPlaying = false;
    try {
      bootReverse.pause();
      bootReverse.playbackRate = 1;
    } catch (e) {}
    sitPlayhead = atEnd ? reverseDuration() || t : Math.max(t, 0.02);
    onReversePainted();
    root.classList.add("is-boot-lift");

    if (!bootVideo) {
      finishLiftOff();
      return;
    }

    try {
      bootVideo.pause();
      bootVideo.loop = false;
      bootVideo.playbackRate = LIFT_RATE;
    } catch (e3) {}

    function onLiftEnded() {
      if (gen !== liftGen || sitDir !== -1) return;
      finishLiftOff();
    }

    function startLiftPlay() {
      if (gen !== liftGen || sitDir !== -1) return;
      var from = introTime();
      if (from <= 0.03) {
        finishLiftOff();
        return;
      }
      liftPlaying = true;
      waitForIntroLiftPaint(gen);
      var startedAt = performance.now();
      function stepLift(now) {
        if (gen !== liftGen || sitDir !== -1) return;
        var target = Math.max(0, from - ((now - startedAt) / 1000) * LIFT_RATE);
        try {
          if (!bootVideo.seeking || target === 0) bootVideo.currentTime = target;
        } catch (e4) {}
        if (target <= 0.001) {
          onLiftEnded();
          return;
        }
        sitRaf = window.requestAnimationFrame(stepLift);
      }
      sitRaf = window.requestAnimationFrame(stepLift);
    }

    function seekThenPlay() {
      if (gen !== liftGen || sitDir !== -1) return;
      if (!introDuration()) {
        bootVideo.addEventListener("loadedmetadata", seekThenPlay, { once: true });
        return;
      }
      var target = introTimeFromReverse();
      if (target < 0.03) target = 0;
      if (Math.abs((bootVideo.currentTime || 0) - target) < 0.05) {
        startLiftPlay();
        return;
      }
      bootVideo.addEventListener(
        "seeked",
        function () {
          if (gen !== liftGen || sitDir !== -1) return;
          startLiftPlay();
        },
        { once: true }
      );
      try {
        bootVideo.currentTime = target;
      } catch (e5) {
        startLiftPlay();
      }
    }

    seekThenPlay();
  }

  function playCompleteLift() {
    if (!bootVideo || (sitDir === -1 && liftPlaying)) return;
    ensureReverseLoaded();
    stopSitRaf();
    liftGen += 1;
    var gen = liftGen;
    var duration = reverseDuration();
    var midpoint = completePauseTime();
    if (!duration || !midpoint) return;
    var from = Math.max(midpoint, Math.min(reverseTime() || duration, duration));
    sitDir = -1;
    liftPlaying = true;
    onReversePainted();
    root.classList.add("is-boot-lift");

    function finish() {
      if (gen !== liftGen || sitDir !== -1) return;
      try {
        bootVideo.pause();
        bootVideo.currentTime = midpoint;
      } catch (e) {}
      finishLiftOff();
    }

    var startedAt = performance.now();
    var lastSeekAt = 0;
    function stepLift(now) {
      if (gen !== liftGen || sitDir !== -1) return;
      var target = Math.max(midpoint, from - ((now - startedAt) / 1000) * LIFT_RATE);
      if (now - lastSeekAt >= 40 || target === midpoint) {
        lastSeekAt = now;
        try {
          if (!bootVideo.seeking || target === midpoint) bootVideo.currentTime = target;
        } catch (e2) {}
      }
      if (target <= midpoint + 0.001) {
        finish();
        return;
      }
      sitRaf = window.requestAnimationFrame(stepLift);
    }

    try {
      bootVideo.pause();
    } catch (e3) {}
    sitRaf = window.requestAnimationFrame(stepLift);
  }

  function bindReverseListeners() {
    if (!bootReverse || reverseLoadStarted) return;
    reverseLoadStarted = true;
    bootReverse.muted = true;
    bootReverse.playsInline = true;
    bootReverse.loop = false;
    bootReverse.preload = "auto";
    bootReverse.playbackRate = 1;
    if (bootReverse !== bootVideo) bootReverse.removeAttribute("crossorigin");
    bootReverse.addEventListener("loadeddata", function () {
      reverseLoaded = bootReverse.readyState >= 2;
    });
    bootReverse.addEventListener("ended", function () {
      if (sitDir === 1) freezeSitEnd();
    });
  }

  function ensureReverseLoaded() {
    if (!bootReverse) return;
    bindReverseListeners();
    reverseLoaded = reverseLoaded || bootReverse.readyState >= 2;
    var src = bootReverse.getAttribute("data-src") || "";
    if (!src || bootReverse.getAttribute("src")) return;
    bootReverse.src = src;
    try {
      bootReverse.load();
    } catch (e) {}
  }

  function playSitForward() {
    if (!bootReverse) return;
    if (completeCycle) {
      playCompleteSit();
      return;
    }
    ensureReverseLoaded();
    liftGen += 1;
    if (liftPlaying && bootVideo) {
      try {
        bootVideo.pause();
      } catch (e0) {}
      var mapped = reverseTimeFromIntro();
      try {
        bootReverse.currentTime = mapped;
      } catch (e1) {}
      sitPlayhead = mapped;
    }
    liftPlaying = false;
    root.classList.remove("is-boot-lift");
    try {
      if (bootVideo) bootVideo.playbackRate = INTRO_RATE;
    } catch (e00) {}
    var dur = bootReverse.duration || 0;
    var t = reverseTime();
    if (sitDir === 1 && !bootReverse.paused && !bootReverse.ended) {
      waitForReversePaint();
      return;
    }
    if (sitShowing && sitDir === 0 && dur && t >= dur - 0.05) return;
    stopSitRaf();
    sitDir = 1;
    var go = function () {
      if (sitDir !== 1 || !bootReverse) return;
      try {
        bootReverse.playbackRate = SIT_RATE;
      } catch (e) {}
      var d = bootReverse.duration || 0;
      var nowT = reverseTime();
      if (d && nowT >= d - 0.04) {
        freezeSitEnd();
        return;
      }
      waitForReversePaint();
      var play = bootReverse.play();
      if (play && typeof play.catch === "function") {
        play.catch(function () {
          if (sitDir === 1 && bootReverse.readyState >= 2) onReversePainted();
        });
      }
    };
    if (bootReverse.readyState >= 2) go();
    else if (!sitReadyBound) {
      sitReadyBound = true;
      bootReverse.addEventListener("loadeddata", go);
      bootReverse.addEventListener("canplay", go);
    }
  }

  function playCompleteSit() {
    if (!bootVideo) return;
    ensureReverseLoaded();
    var duration = reverseDuration();
    var midpoint = completePauseTime();
    if (!duration || !midpoint) return;
    if (sitDir === 1 && !bootVideo.paused && !bootVideo.ended) return;
    if (sitShowing && sitDir === 0 && isPlantedEnd()) return;
    liftGen += 1;
    stopSitRaf();
    liftPlaying = false;
    sitDir = 1;
    root.classList.remove("is-boot-lift");
    var current = reverseTime();
    var mapped = current < midpoint - 0.025 ? duration - current : current;

    function go() {
      if (sitDir !== 1) return;
      if (reverseTime() >= duration - 0.04) {
        freezeSitEnd();
        return;
      }
      try {
        bootVideo.playbackRate = SIT_RATE;
      } catch (e) {}
      waitForReversePaint();
      var play = bootVideo.play();
      if (play && typeof play.catch === "function") play.catch(function () {});
    }

    try {
      bootVideo.pause();
      bootVideo.currentTime = Math.max(midpoint, Math.min(mapped, duration));
    } catch (e2) {}
    if (Math.abs(reverseTime() - mapped) < 0.03 && !bootVideo.seeking) go();
    else bootVideo.addEventListener("seeked", go, { once: true });
  }

  function syncBootVisual(sp, introComplete) {
    if (!bootVideo) return;
    if (bootVideo.hasAttribute("poster")) bootVideo.removeAttribute("poster");
    if (!introComplete) {
      if (sitShowing || sitDir) finishLiftOff();
      return;
    }

    if (introComplete && landingT(sp) >= 0.12) ensureReverseLoaded();

    var scrollDir = noteScrollDir(sp);
    var hasPlant =
      sitShowing ||
      sitDir !== 0 ||
      (bootReverse && (bootReverse.ended || reverseTime() > 0.03));

    if (scrollDir < 0 && hasPlant) {
      playSitRewind();
      return;
    }

    if (landingT(sp) >= SIT_TRIGGER && sitDir !== -1) {
      playSitForward();
      return;
    }

    if (scrollDir > 0 && sitDir === -1 && landingT(sp) >= SIT_TRIGGER) {
      playSitForward();
      return;
    }

    if (sitDir === -1) return;

    if (sitShowing || sitDir === 1) playSitRewind();
  }

  function finishIntro() {
    if (introDone) return;
    if (introReverseRaf) {
      window.cancelAnimationFrame(introReverseRaf);
      introReverseRaf = 0;
    }
    introDone = true;
    debugSet("boot.intro", "finished time=" + (bootVideo ? reverseTime().toFixed(2) : "none"));
    introT = 1;
    root.classList.remove("is-intro");
    root.classList.add("is-intro-done");
    document.dispatchEvent(new CustomEvent("tr20:intro-done"));
    setScrollLock(false);
    try {
      if (bootVideo) bootVideo.pause();
    } catch (e) {}
    paintAndRevealBoot(bootVideo, 180);
    if (!heatStart) heatStart = performance.now();
    scrollP = stickyProgress(track);
    applyScene();
    requestDraw();
  }

  function introTick() {
    if (introDone || !bootVideo) return;
    if (bootVideo.duration) introT = clamp(bootVideo.currentTime / bootVideo.duration, 0, 1);
    applyScene();
    requestDraw();
    if (bootVideo.ended || (introStarted && bootVideo.paused && introT > 0.98)) {
      finishIntro();
      return;
    }
    if (!bootVideo.paused && bootVideo.requestVideoFrameCallback) bootVideo.requestVideoFrameCallback(introTick);
    else window.requestAnimationFrame(introTick);
  }

  function seekCompletePause(done) {
    var midpoint = completePauseTime();
    if (!bootVideo || !midpoint) {
      done();
      return;
    }
    var finished = false;
    function complete() {
      if (finished) return;
      finished = true;
      paintBootFrame(bootVideo);
      done();
    }
    try {
      bootVideo.pause();
      bootVideo.currentTime = midpoint;
    } catch (e) {
      complete();
      return;
    }
    if (!bootVideo.seeking && Math.abs(reverseTime() - midpoint) < 0.03) {
      window.requestAnimationFrame(complete);
    } else {
      bootVideo.addEventListener("seeked", complete, { once: true });
      window.setTimeout(complete, 400);
    }
  }

  function playCompleteIntro() {
    function start() {
      var midpoint = completePauseTime();
      if (!midpoint) {
        finishIntro();
        return;
      }
      var stopped = false;
      function stopAtMidpoint() {
        if (stopped || introDone) return;
        stopped = true;
        seekCompletePause(finishIntro);
      }
      function watch() {
        if (introDone || stopped) return;
        introT = clamp(reverseTime() / midpoint, 0, 1);
        applyScene();
        requestDraw();
        if (reverseTime() >= midpoint - 0.025) {
          stopAtMidpoint();
          return;
        }
        if (typeof bootVideo.requestVideoFrameCallback === "function") {
          bootVideo.requestVideoFrameCallback(watch);
        } else {
          introReverseRaf = window.requestAnimationFrame(watch);
        }
      }
      function go() {
        if (introDone) return;
        paintAndRevealBoot(bootVideo, 90);
        try {
          bootVideo.playbackRate = INTRO_RATE;
        } catch (e) {}
        var play = bootVideo.play();
        if (play && typeof play.then === "function") {
          play.then(function () {
            debugSet("boot.play", "ok");
          }).catch(function (error) {
            debugSet("boot.play", "FAIL " + (error && error.name ? error.name : error));
            activateMediaFallback("boot playback blocked: " + (error && error.name ? error.name : error));
            showBootFallback();
            finishIntro();
          });
        }
        watch();
      }
      try {
        bootVideo.pause();
        bootVideo.currentTime = 0;
      } catch (e2) {}
      if (!bootVideo.seeking && reverseTime() < 0.03) go();
      else bootVideo.addEventListener("seeked", go, { once: true });
    }

    if (reverseDuration()) start();
    else bootVideo.addEventListener("loadedmetadata", start, { once: true });
  }

  function startIntro() {
    if (introDone) return;
    if (!introStartReady) {
      if (introStartQueued) return;
      introStartQueued = true;
      window.setTimeout(function () {
        introStartQueued = false;
        introStartReady = true;
        startIntro();
      }, 220);
      return;
    }
    if (introStarted || !bootVideo) {
      if (!bootVideo) finishIntro();
      return;
    }
    if (window.scrollY > 24 || root.getBoundingClientRect().top < -24) {
      root.setAttribute("data-intro-mode", "skipped-restored-scroll");
      introStarted = true;
      introT = 1;
      heatStart = performance.now() - HEAT_MS;
      if (completeCycle) seekCompletePause(finishIntro);
      else {
        try {
          if (bootVideo.duration) bootVideo.currentTime = 0;
        } catch (e) {}
        finishIntro();
      }
      return;
    }
    if (!reducedMotion) {
      var bufferedRatio = bootBufferedRatio();
      if (!bootBufferWaitStarted) bootBufferWaitStarted = performance.now();
      var bufferWait = performance.now() - bootBufferWaitStarted;
      debugSet("boot.buffer", Math.round(bufferedRatio * 100) + "% wait=" + Math.round(bufferWait) + "ms");
      if (bufferedRatio < BOOT_BUFFER_RATIO && bufferWait < BOOT_BUFFER_MAX_WAIT) {
        warmBootBuffer();
        if (!bootBufferTimer) {
          bootBufferTimer = window.setTimeout(function () {
            bootBufferTimer = 0;
            startIntro();
          }, 120);
        }
        return;
      }
      if (bufferedRatio < BOOT_BUFFER_RATIO && mediaFallbackActive) {
        debugSet("boot.buffer", Math.round(bufferedRatio * 100) + "% — CSS fallback");
        showBootFallback();
        finishIntro();
        return;
      }
      finishBootBufferWarmup();
      debugSet("boot.buffer", Math.round(bufferedRatio * 100) + "% starting");
    }
    root.setAttribute("data-intro-mode", "played");
    introStarted = true;
    root.classList.add("is-intro");
    heatStart = performance.now();
    if (reducedMotion) {
      introT = 1;
      heatStart = performance.now() - HEAT_MS;
      activateMediaFallback("reduced motion static boot");
      showBootFallback();
      finishIntro();
      return;
    }
    if (completeCycle) {
      root.setAttribute("data-intro-mode", "complete-cycle");
      setScrollLock(true);
      bootVideo.muted = true;
      bootVideo.playsInline = true;
      bootVideo.loop = false;
      introT = 0;
      window.setTimeout(function () {
        if (!introDone) {
          debugSet("boot.intro", "watchdog fallback ready=" + bootVideo.readyState + " network=" + bootVideo.networkState);
          seekCompletePause(finishIntro);
        }
      }, iosVideoMode ? 4000 : 15000);
      playCompleteIntro();
      return;
    }
    if (iosVideoMode) {
      root.setAttribute("data-intro-mode", "static-ios");
      introT = 1;
      heatStart = performance.now() - HEAT_MS;
      try {
        bootVideo.pause();
        bootVideo.currentTime = 0;
      } catch (e0) {}
      var iosFinished = false;
      var finishIOSIntro = function () {
        if (iosFinished || introDone) return;
        iosFinished = true;
        paintBootFrame(bootVideo);
        finishIntro();
      };
      if (typeof bootVideo.requestVideoFrameCallback === "function") {
        bootVideo.requestVideoFrameCallback(finishIOSIntro);
        window.setTimeout(finishIOSIntro, 240);
      } else {
        window.requestAnimationFrame(finishIOSIntro);
      }
      return;
    }
    setScrollLock(true);
    bootVideo.muted = true;
    bootVideo.playsInline = true;
    bootVideo.loop = false;
    introT = 0;
    window.setTimeout(function () {
      if (!introDone) finishIntro();
    }, 15000);

    function playIntro() {
      var duration = introDuration();
      if (!duration) {
        introT = 1;
        finishIntro();
        return;
      }
      var firstFrame = Math.max(duration - 0.08, 0);
      try {
        bootVideo.pause();
        bootVideo.currentTime = firstFrame;
      } catch (e1) {}

      var clockStarted = false;
      function startClock() {
        if (clockStarted || introDone) return;
        clockStarted = true;
        if (typeof bootVideo.__tr20DrawStackedFrame === "function") {
          bootVideo.__tr20DrawStackedFrame();
        }
        root.classList.remove("is-boot-preparing");
        revealBootMedia();
        var startedAt = performance.now();
        var lastSeekAt = 0;
        function stepIntro(now) {
          if (introDone) return;
          var target = Math.max(0, duration - ((now - startedAt) / 1000) * INTRO_RATE);
          introT = clamp(1 - target / duration, 0, 1);
          if (now - lastSeekAt >= 45 || target === 0) {
            lastSeekAt = now;
            try {
              if (!bootVideo.seeking || target === 0) bootVideo.currentTime = target;
            } catch (e2) {}
          }
          applyScene();
          requestDraw();
          if (target <= 0.001) {
            finishIntro();
            return;
          }
          introReverseRaf = window.requestAnimationFrame(stepIntro);
        }
        introReverseRaf = window.requestAnimationFrame(stepIntro);
      }

      function waitForFirstFrame() {
        if (introDone || clockStarted) return;
        if (
          bootVideo.readyState < 2 ||
          bootVideo.seeking ||
          Math.abs((bootVideo.currentTime || 0) - firstFrame) > 0.06
        ) {
          introReverseRaf = window.requestAnimationFrame(waitForFirstFrame);
          return;
        }
        if (typeof bootVideo.requestVideoFrameCallback === "function") {
          bootVideo.requestVideoFrameCallback(function (_now, metadata) {
            var mediaTime = metadata && typeof metadata.mediaTime === "number" ? metadata.mediaTime : firstFrame;
            if (mediaTime < firstFrame - 0.06) {
              try {
                bootVideo.currentTime = firstFrame;
              } catch (e3) {}
              introReverseRaf = window.requestAnimationFrame(waitForFirstFrame);
              return;
            }
            startClock();
          });
          window.setTimeout(startClock, 260);
        } else {
          window.requestAnimationFrame(startClock);
        }
      }
      waitForFirstFrame();
    }

    bootVideo.addEventListener("canplay", playIntro, { once: true });
    try {
      bootVideo.load();
    } catch (e0) {
      playIntro();
    }
  }

  function applyScene() {
    var mobile = isMobile();
    var reveal = introDone ? 1 : introT;
    var sp = introDone ? scrollP : 0;
    var pose = bootPose(reveal, sp, mobile);
    var beats = [
      envelope(sp, BEATS[0][0], BEATS[0][1]),
      envelope(sp, BEATS[1][0], BEATS[1][1]),
      envelope(sp, BEATS[2][0], BEATS[2][1]),
      envelope(sp, BEATS[3][0], BEATS[3][1]),
    ];
    var ui = sceneNavOpacity(sp, introDone);
    var shownPose = applyShown(
      pose,
      groundOpacity(reveal, sp),
      groundRise(reveal, sp),
      bootShadow(reveal, sp),
      bootInset(sp),
      ui
    );

    root.style.setProperty("--p", String(sp));
    root.style.setProperty("--sig", String(signatureOpacity(sp, introDone, shownPose.ui)));
    root.style.setProperty("--b0", String(beats[0]));
    root.style.setProperty("--b1", String(beats[1]));
    root.style.setProperty("--b2", String(beats[2]));
    root.style.setProperty("--b3", String(beats[3]));
    root.style.setProperty("--boot-x", shownPose.x + "%");
    root.style.setProperty("--boot-y", shownPose.y + "%");
    root.style.setProperty("--boot-s", String(shownPose.s));
    root.style.setProperty("--boot-r", shownPose.r.toFixed(3) + "deg");
    root.style.setProperty("--boot-o", String(shownPose.o));
    root.style.setProperty("--boot-b", "1");
    root.style.setProperty("--ground", String(shownPose.ground));
    root.style.setProperty("--ground-y", shownPose.groundY.toFixed(2) + "vh");
    updateGroundRest();
    root.style.setProperty("--boot-shadow", String(shownPose.shadow));
    root.style.setProperty("--boot-inset", String(shownPose.inset));
    root.style.setProperty("--ui", String(shownPose.ui));
    var canvasO = canvasOpacity(sp);
    root.style.setProperty("--canvas-o", String(canvasO));
    if (canvas) canvas.style.opacity = String(canvasO);
    root.style.setProperty("--copy-landing", String(1 - smoother(landingT(sp) / 0.62)));
    updateCanvasPlacement(sp);
    root.classList.toggle("is-landed", sp >= 0.992);
    root.classList.toggle("has-scene-nav", shownPose.ui > 0.04);
    root.setAttribute("data-p", sp.toFixed(3));
    root.setAttribute("data-intro", introT.toFixed(3));
    root.setAttribute("data-heat", heroHeat(reveal, sp).toFixed(3));

    state.p = sp;
    state.heroHeat = heroHeat(reveal, sp) * (mobile && sp > 0 ? 0.78 : 1);
    state.grain = grainSetting * (sp >= LANDING ? mix(1.35, 1.55, landingT(sp)) : 1.35);
    state.blur = blurAmount(reveal, sp);
    state.mark = mediaFallbackActive ? 0 : markAmount(reveal, sp) * (mobile ? 0.78 : 1);
    state.videoTiles = 1;
    state.markTiles = markTilesFor(sp, introDone);
    state.tileMix = tileMixFor(sp, introDone);
    activateCopyBeat(sp);
    updateCopyMask(sp);
    state.videoFade = originVideoFade(sp);
    if (introDone) syncBeatVideo(sp);
    else state.hasVideo = 0;
    if (!reducedMotion) syncBootVisual(sp, introDone);
  }

  function mountPageGrain() {
    if (!document.querySelector(".tr20-page-heatmap")) {
      var heatmap = document.createElement("div");
      heatmap.className = "tr20-page-heatmap";
      heatmap.setAttribute("aria-hidden", "true");
      document.body.insertBefore(heatmap, document.body.firstChild);
    }
    if (document.querySelector(".tr20-page-grain")) return;
    var c = document.createElement("canvas");
    c.width = 128;
    c.height = 128;
    var ctx = c.getContext("2d");
    if (!ctx) return;
    var img = ctx.createImageData(128, 128);
    for (var i = 0; i < img.data.length; i += 4) {
      var n = 62 + Math.random() * 130;
      img.data[i] = n;
      img.data[i + 1] = n;
      img.data[i + 2] = n;
      img.data[i + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    var el = document.createElement("div");
    el.className = "tr20-page-grain";
    el.setAttribute("aria-hidden", "true");
    el.style.backgroundImage = "url(" + c.toDataURL("image/png") + ")";
    document.body.appendChild(el);
  }

  function compile(type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      var shaderError = gl.getShaderInfoLog(shader) || "unknown shader error";
      console.warn("TR20 origin shader", shaderError);
      debugSet("origin.shader", "FAIL " + shaderError);
      gl.deleteShader(shader);
      return null;
    }
    return shader;
  }

  function uploadTex(source, wrapS, wrapT) {
    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrapS);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrapT);
    return tex;
  }

  function bakeSoftMark(width, height, blurPx, coreAlpha, draw) {
    var sharp = document.createElement("canvas");
    sharp.width = width;
    sharp.height = height;
    var sctx = sharp.getContext("2d");
    sctx.clearRect(0, 0, width, height);
    draw(sctx);

    var out = document.createElement("canvas");
    out.width = width;
    out.height = height;
    var ctx = out.getContext("2d");
    ctx.clearRect(0, 0, width, height);
    if (typeof ctx.filter === "string") {
      ctx.filter = "blur(" + Math.round(blurPx * 1.75) + "px)";
      ctx.globalAlpha = 0.55;
      ctx.drawImage(sharp, 0, 0);
      ctx.filter = "blur(" + Math.round(blurPx) + "px)";
      ctx.globalAlpha = 1;
      ctx.drawImage(sharp, 0, 0);
      ctx.filter = "none";
      ctx.globalAlpha = coreAlpha;
      ctx.drawImage(sharp, 0, 0);
    } else {
      ctx.drawImage(sharp, 0, 0);
    }
    return out;
  }

  function makeHeroTexture() {
    var baked = bakeSoftMark(1024, 512, 56, 0.28, function (ctx) {
      ctx.fillStyle = "#fff";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "700 268px 'PS DM Mono', 'DM Mono', monospace";
      ctx.fillText("TR20", 512, 256);
    });
    return uploadTex(baked, gl.CLAMP_TO_EDGE, gl.CLAMP_TO_EDGE);
  }

  function makeTileTexture() {
    var probe = document.createElement("canvas").getContext("2d");
    probe.font = "700 220px 'PS DM Mono', 'DM Mono', monospace";
    var metrics = probe.measureText("TR20");
    var asc = Math.ceil(metrics.actualBoundingBoxAscent || 168);
    var desc = Math.ceil(metrics.actualBoundingBoxDescent || 48);
    var tw = Math.ceil(metrics.width);
    var th = asc + desc;
    var gapX = 0.16;
    var gapTop = 0.3;
    var gapBottom = 0.16;
    var cellW = Math.ceil(tw / (1 - gapX * 2));
    var cellH = Math.ceil(th / (1 - gapTop - gapBottom));
    var padTop = Math.round(cellH * gapTop);
    var baked = bakeSoftMark(cellW, cellH, 44, 0.26, function (ctx) {
      ctx.fillStyle = "#fff";
      ctx.textAlign = "center";
      ctx.textBaseline = "alphabetic";
      ctx.font = "700 220px 'PS DM Mono', 'DM Mono', monospace";
      ctx.fillText("TR20", cellW / 2, padTop + asc);
    });
    state.tileAspect = baked.width / Math.max(baked.height, 1);
    return uploadTex(baked, gl.CLAMP_TO_EDGE, gl.CLAMP_TO_EDGE);
  }

  function makeVideoTexture() {
    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 2, 2, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(16));
    return tex;
  }

  function fitFrameSource(source, sourceW, sourceH) {
    if (!videoFrameCtx || !source || !sourceW) return source;
    var targetWidth = isMobile() ? 270 : 360;
    var targetHeight = Math.max(1, Math.round((targetWidth * sourceH) / sourceW));
    if (videoFrameCanvas.width !== targetWidth || videoFrameCanvas.height !== targetHeight) {
      videoFrameCanvas.width = targetWidth;
      videoFrameCanvas.height = targetHeight;
    }
    videoFrameCtx.drawImage(source, 0, 0, targetWidth, targetHeight);
    return videoFrameCanvas;
  }

  function videoFrameSource(video) {
    if (!video || !video.videoWidth) return video;
    return fitFrameSource(video, video.videoWidth, video.videoHeight);
  }

  function initGL() {
    if (!canvas) return false;
    gl = canvas.getContext("webgl", {
      alpha: false,
      antialias: false,
      depth: false,
      stencil: false,
      powerPreference: iosVideoMode ? "default" : "low-power",
      failIfMajorPerformanceCaveat: false,
    }) || canvas.getContext("experimental-webgl");
    if (!gl) {
      canvas.classList.add("is-fallback");
      debugSet("origin.webgl", "FAIL context");
      return false;
    }

    debugSet("origin.webgl", "context ok maxTexture=" + gl.getParameter(gl.MAX_TEXTURE_SIZE));
    canvas.addEventListener("webglcontextlost", function (event) {
      event.preventDefault();
      canvas.classList.add("is-fallback");
      debugSet("origin.webgl", "FAIL context lost");
    });
    canvas.addEventListener("webglcontextrestored", function () {
      debugSet("origin.webgl", "context restored — reload page");
    });

    var vsSource = "attribute vec2 a_pos;void main(){gl_Position=vec4(a_pos,0.0,1.0);}";
    var fsSource = [
      iosVideoMode ? "precision mediump float;" : "precision highp float;",
      "uniform vec2 u_res;",
      "uniform float u_time;",
      "uniform float u_progress;",
      "uniform float u_heroHeat;",
      "uniform float u_grain;",
      "uniform float u_blur;",
      "uniform float u_markAmount;",
      "uniform float u_markTiles;",
      "uniform float u_tileMix;",
      "uniform float u_tileAspect;",
      "uniform vec2 u_copyCenter;",
      "uniform vec2 u_copyRadii;",
      "uniform float u_copyStrength;",
      "uniform float u_copyBand;",
      "uniform float u_hasVideo;",
      "uniform float u_videoFade;",
      "uniform float u_videoAspect;",
      "uniform float u_videoTiles;",
      "uniform sampler2D u_mark;",
      "uniform sampler2D u_tiles;",
      "uniform sampler2D u_video;",
      "float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}",
      "float noise(vec2 p){vec2 i=floor(p);vec2 f=fract(p);float a=hash(i);float b=hash(i+vec2(1.0,0.0));float c=hash(i+vec2(0.0,1.0));float d=hash(i+vec2(1.0,1.0));vec2 u=f*f*(3.0-2.0*f);return mix(a,b,u.x)+(c-a)*u.y*(1.0-u.x)+(d-b)*u.x*u.y;}",
      "float fbm(vec2 p){float v=0.0;float a=0.5;for(int i=0;i<5;i++){v+=a*noise(p);p*=2.03;a*=0.5;}return v;}",
      "float tvGrain(vec2 frag,float time){",
      "float frame=floor(time*78.0);",
      "vec2 p=floor(frag);",
      "float s=hash(p+vec2(frame*19.13,frame*7.27));",
      "float s2=hash(p*1.61+vec2(frame*4.19,-frame*11.3));",
      "float fine=hash(p*2.17+vec2(floor(time*110.0)*8.3,-floor(time*110.0)*3.1));",
      "float scan=0.5+0.5*sin(frag.y*0.78+time*28.0);",
      "return (s*0.45+s2*0.25+fine*0.3-0.5)*mix(0.78,1.22,scan);",
      "}",
      "vec3 lut(float t){t=clamp(t,0.0,1.0);t=pow(t,1.12);vec3 c0=vec3(0.0);vec3 c1=vec3(0.118,0.0,0.255);vec3 c2=vec3(0.02,0.0,0.92);vec3 c3=vec3(0.92,0.0,0.48);vec3 c4=vec3(1.0,0.78,0.0);vec3 c5=vec3(0.32,0.92,0.0);vec3 c6=vec3(0.92,0.62,1.0);if(t<0.18)return mix(c0,c1,t/0.18);if(t<0.38)return mix(c1,c2,(t-0.18)/0.20);if(t<0.62)return mix(c2,c3,(t-0.38)/0.24);if(t<0.78)return mix(c3,c4,(t-0.62)/0.16);if(t<0.9)return mix(c4,c5,(t-0.78)/0.12);return mix(c5,c6,(t-0.9)/0.10);}",
      "vec2 videoUv(vec2 uv){",
      "float tileW=max(u_videoAspect,0.05)*(u_res.y/max(u_res.x,1.0));",
      "vec2 cell=vec2(uv.x/max(tileW,0.001),uv.y);",
      "vec2 id=floor(cell);",
      "vec2 f=fract(cell);",
      "f.x=mix(f.x,1.0-f.x,step(0.5,mod(id.x,2.0)));",
      "f.y=mix(f.y,1.0-f.y,step(0.5,mod(id.y,2.0)));",
      "f.y=1.0-f.y;",
      "return f;",
      "}",
      "vec2 heroUv(vec2 uv){",
      "vec2 p=uv-vec2(0.5,0.445);",
      "p.x*=u_res.x/max(u_res.y,1.0);",
      "p/=1.22;",
      "p/=vec2(2.0,1.0);",
      "return p+0.5;",
      "}",
      "float sampleHero(vec2 uv){",
      "return texture2D(u_mark,clamp(heroUv(uv),0.0,1.0)).a*mix(1.0,0.72,smoothstep(0.8,1.0,u_progress));",
      "}",
      "vec2 tileCellUv(vec2 uv){",
      "float cols=max(u_markTiles,0.35);",
      "float aspect=max(u_tileAspect,1.15);",
      "float rows=cols*(u_res.y/max(u_res.x,1.0))*aspect;",
      "vec2 p=(uv-vec2(0.0,0.055))-0.5;",
      "float row=floor(p.y*rows+0.5);",
      "float stagger=mod(row,2.0)*0.5;",
      "vec2 grid=vec2(p.x*cols+stagger,p.y*rows);",
      "return fract(grid+0.5);",
      "}",
      "float tileVisible(vec2 uv){",
      "float cols=max(u_markTiles,0.35);",
      "float aspect=max(u_tileAspect,1.15);",
      "float rows=cols*(u_res.y/max(u_res.x,1.0))*aspect;",
      "vec2 p=(uv-vec2(0.0,0.055))-0.5;",
      "float row=floor(p.y*rows+0.5);",
      "float stagger=mod(row,2.0)*0.5;",
      "vec2 id=floor(vec2(p.x*cols+stagger,p.y*rows)+0.5);",
      "float cheb=max(abs(id.x),abs(id.y));",
      "return mix(1.0-step(0.51,cheb),1.0,smoothstep(0.85,1.85,cols));",
      "}",
      "float sampleTiles(vec2 uv){",
      "vec2 t=tileCellUv(uv);",
      "float vis=tileVisible(uv);",
      "return vis*texture2D(u_tiles,t).a;",
      "}",
      "void main(){",
      "vec2 uv=gl_FragCoord.xy/u_res;",
      "vec2 p=uv*vec2(u_res.x/max(u_res.y,1.0),1.0);",
      "float t=u_time*0.18;",
      "float n=fbm(p*3.2+vec2(t*1.05,t*0.62));",
      "float n2=fbm(p*6.8-vec2(t*0.48,-t*0.7));",
      "float grain=tvGrain(gl_FragCoord.xy,u_time);",
      "float pageLuma=mix(0.0,0.1,n*0.78+n2*0.18)*mix(0.18,1.0,smoothstep(0.0,0.48,u_heroHeat));",
      "vec2 vuv=videoUv(uv);",
      "vec3 vid=texture2D(u_video,vuv).rgb;",
      "float vLuma=dot(vid,vec3(0.299,0.587,0.114));",
      "vLuma=pow(max(vLuma,0.0),0.78);",
      "vLuma=clamp((vLuma-0.38)*1.55+0.66,0.0,1.0);",
      "vec2 px=u_blur*7.2/u_res;",
      "float vBlur=(texture2D(u_video,videoUv(uv+vec2(px.x,0.0))).g+texture2D(u_video,videoUv(uv-vec2(px.x,0.0))).g+texture2D(u_video,videoUv(uv+vec2(0.0,px.y))).g+texture2D(u_video,videoUv(uv-vec2(0.0,px.y))).g+texture2D(u_video,videoUv(uv+px)).g+texture2D(u_video,videoUv(uv-px)).g)/6.0;",
      "vLuma=mix(vLuma,vBlur,clamp(u_blur,0.0,1.0)*0.7);",
      "float landingVideo=1.0-smoothstep(0.88,0.955,u_progress);",
      "float vidAmt=u_hasVideo*u_videoFade*landingVideo;",
      "float heroLuma=mix(smoothstep(0.14,0.9,n*0.58+n2*0.48), vLuma, vidAmt*0.98);",
      "float luma=mix(pageLuma,heroLuma,clamp(u_heroHeat,0.0,1.2));",
      "float mark=sampleTiles(uv);",
      "luma+=mark*u_markAmount*0.52;",
      "float restDark=smoothstep(0.88,0.97,u_progress);",
      "luma*=mix(1.0,0.7,restDark);",
      "vec2 d=(uv-u_copyCenter)/max(u_copyRadii,vec2(0.001));",
      "float ellipse=exp(-dot(d,d));",
      "float band=smoothstep(0.42,0.9,1.0-uv.y);",
      "float copyMask=mix(ellipse,band,u_copyBand)*u_copyStrength;",
      "luma*=mix(1.0,0.2,copyMask);",
      "float darkGrain=grain*u_grain*0.18*mix(0.62,1.0,smoothstep(0.72,0.04,luma));",
      "float vidGrain=grain*u_grain*0.19*vidAmt;",
      "luma+=mix(darkGrain,vidGrain+darkGrain*0.45,vidAmt)*(1.0-copyMask*0.4);",
      "luma=clamp(luma,0.0,1.0);",
      "gl_FragColor=vec4(lut(luma),1.0);",
      "}",
    ].join("");

    var vs = compile(gl.VERTEX_SHADER, vsSource);
    var fs = compile(gl.FRAGMENT_SHADER, fsSource);
    if (!vs || !fs) {
      canvas.classList.add("is-fallback");
      debugSet("origin.webgl", "FAIL shader compile");
      return false;
    }

    program = gl.createProgram();
    gl.attachShader(program, vs);
    gl.attachShader(program, fs);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      canvas.classList.add("is-fallback");
      debugSet("origin.webgl", "FAIL program link " + (gl.getProgramInfoLog(program) || "unknown"));
      return false;
    }

    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var aPos = gl.getAttribLocation(program, "a_pos");
    gl.useProgram(program);
    gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

    uniforms = {
      res: gl.getUniformLocation(program, "u_res"),
      time: gl.getUniformLocation(program, "u_time"),
      progress: gl.getUniformLocation(program, "u_progress"),
      heroHeat: gl.getUniformLocation(program, "u_heroHeat"),
      grain: gl.getUniformLocation(program, "u_grain"),
      blur: gl.getUniformLocation(program, "u_blur"),
      markAmount: gl.getUniformLocation(program, "u_markAmount"),
      markTiles: gl.getUniformLocation(program, "u_markTiles"),
      tileMix: gl.getUniformLocation(program, "u_tileMix"),
      tileAspect: gl.getUniformLocation(program, "u_tileAspect"),
      copyCenter: gl.getUniformLocation(program, "u_copyCenter"),
      copyRadii: gl.getUniformLocation(program, "u_copyRadii"),
      copyStrength: gl.getUniformLocation(program, "u_copyStrength"),
      copyBand: gl.getUniformLocation(program, "u_copyBand"),
      hasVideo: gl.getUniformLocation(program, "u_hasVideo"),
      videoFade: gl.getUniformLocation(program, "u_videoFade"),
      videoAspect: gl.getUniformLocation(program, "u_videoAspect"),
      videoTiles: gl.getUniformLocation(program, "u_videoTiles"),
      mark: gl.getUniformLocation(program, "u_mark"),
      tiles: gl.getUniformLocation(program, "u_tiles"),
      video: gl.getUniformLocation(program, "u_video"),
    };

    markTex = makeHeroTexture();
    tileTex = makeTileTexture();
    videoTex = makeVideoTexture();
    debugSet("origin.shader", "linked precision=" + (iosVideoMode ? "mediump" : "highp"));
    return true;
  }

  function resize() {
    if (!gl || !canvas) return;
    var box = sticky || canvas.parentElement || canvas;
    var rect = box.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, window.innerWidth < 900 ? 0.68 : 0.82);
    width = Math.max(1, Math.floor(Math.max(rect.width, 1) * dpr));
    height = Math.max(1, Math.floor(Math.max(rect.height, 1) * dpr));
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, width, height);
  }

  var looping = false;

  function draw(now) {
    drawing = false;
    if (!gl || !inView) {
      looping = false;
      return;
    }
    if (document.visibilityState === "hidden") {
      looping = false;
      return;
    }
    if (!reducedMotion && lastRenderAt && now - lastRenderAt < FRAME_INTERVAL) {
      window.requestAnimationFrame(draw);
      return;
    }
    lastRenderAt = now;

    if (copyMaskAt >= 0 && now - copyMaskAt < COPY_MASK_MS + 50) applyScene();
    else if (bootNudgeAt >= 0 && now - bootNudgeAt < 180) applyScene();
    else if (heatStart && now - heatStart < HEAT_MS && scrollP < LANDING) applyScene();
    else if (poseSettling) applyScene();

    var liveVideo = activeBeatVideo && activeBeatVideo.readyState >= 2;
    var texReady = uploadBeatFrame(liveVideo);
    stepVideoReveal(now, texReady);
    state.videoFade = originVideoFade(scrollP);
    state.hasVideo = state.videoFade > 0.01 && texReady ? 1 : 0;
    if (liveVideo && activeBeatVideo.videoWidth > 1) {
      state.videoAspect = activeBeatVideo.videoWidth / Math.max(activeBeatVideo.videoHeight, 1);
    }

    var time = reducedMotion ? 0.45 : (now - start) / 1000;
    gl.useProgram(program);
    gl.uniform2f(uniforms.res, width, height);
    gl.uniform1f(uniforms.time, time);
    gl.uniform1f(uniforms.progress, state.p);
    gl.uniform1f(uniforms.heroHeat, state.heroHeat);
    gl.uniform1f(uniforms.grain, state.grain);
    gl.uniform1f(uniforms.blur, state.blur);
    gl.uniform1f(uniforms.markAmount, state.mark);
    gl.uniform1f(uniforms.markTiles, state.markTiles);
    gl.uniform1f(uniforms.tileMix, state.tileMix);
    gl.uniform1f(uniforms.tileAspect, state.tileAspect);
    gl.uniform2f(uniforms.copyCenter, state.copyX, state.copyY);
    gl.uniform2f(uniforms.copyRadii, state.copyRx, state.copyRy);
    gl.uniform1f(uniforms.copyStrength, state.copyStrength);
    gl.uniform1f(uniforms.copyBand, state.copyBand);
    gl.uniform1f(uniforms.hasVideo, state.hasVideo);
    gl.uniform1f(uniforms.videoFade, state.videoFade);
    gl.uniform1f(uniforms.videoAspect, state.videoAspect);
    gl.uniform1f(uniforms.videoTiles, state.videoTiles);

    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, markTex);
    gl.uniform1i(uniforms.mark, 0);

    gl.activeTexture(gl.TEXTURE1);
    gl.bindTexture(gl.TEXTURE_2D, videoTex);
    gl.uniform1i(uniforms.video, 1);

    gl.activeTexture(gl.TEXTURE2);
    gl.bindTexture(gl.TEXTURE_2D, tileTex);
    gl.uniform1i(uniforms.tiles, 2);

    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    if (!reducedMotion && inView) {
      looping = true;
      window.requestAnimationFrame(draw);
    } else {
      looping = false;
    }
  }

  function requestDraw() {
    if (looping || drawing || !gl) return;
    drawing = true;
    looping = true;
    window.requestAnimationFrame(draw);
  }

  function updateAll() {
    raf = 0;
    measureNav();
    scrollP = introDone || reducedMotion ? stickyProgress(track) : 0;
    applyScene();
    requestDraw();
  }

  function onScrollResize() {
    if (raf) return;
    raf = window.requestAnimationFrame(updateAll);
  }

  if (initGL()) {
    resize();
    window.addEventListener("resize", function () {
      resize();
      updateGroundRest(true);
      onScrollResize();
    });
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState !== "hidden") requestDraw();
    });
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var rootVisible = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          inView = rootVisible || pageBackground;
          if (inView) requestDraw();
        },
        { rootMargin: "20% 0px" }
      );
      io.observe(root);
    }
  }

  document.addEventListener("scroll", onScrollResize, { passive: true });
  window.addEventListener("resize", onScrollResize);

  navButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var index = parseInt(button.getAttribute("data-beat-nav") || "-1", 10);
      if (index >= 0) goToBeat(index);
    });
  });

  bindBootThenBeat();
  bindReverseListeners();

  if (bootVideo) {
    bootVideo.addEventListener("tr20:stacked-ready", hideBootFallback);
    bootVideo.addEventListener("tr20:stacked-error", showBootFallback);
    bootVideo.addEventListener("error", function () {
      showBootFallback();
      if (!iosVideoMode) return;
      bootFullyLoaded = true;
      tryStartBeatVideo();
      seekCompletePause(finishIntro);
    });
    bootVideo.addEventListener("ended", finishIntro);
    if (bootVideo.readyState >= 1) startIntro();
    else {
      bootVideo.addEventListener("loadedmetadata", startIntro, { once: true });
      bootVideo.addEventListener("loadeddata", startIntro, { once: true });
      bootVideo.addEventListener("canplay", startIntro, { once: true });
    }
  } else {
    var bootImg = root.querySelector(".tr20-origin__boot-img");
    if (bootImg) {
      window.requestAnimationFrame(function () {
        bootImg.classList.add("is-revealed");
      });
    }
    introT = 1;
    finishIntro();
  }

  mountPageGrain();
  updateAll();
})();
